module.exports = __webpack_public_path__ + "img/4,w_883.bd0acc5c.jpg";